import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';

import { getCompany, getSubcompany } from 'auth/selectors';

import {
  getDisabledReportPagination,
  getDisabledReportFilters,
  getDisabledReportNeedFetch,
} from 'reports/selectors';

import {
  getDisabledReport,
  getDisabledReportCSV,
  getDisabledReportXLSX,
  getDisabledReportPDF,
  resetDisabledReport,
  setDisabledReportFilters,
  setDisabledReportPagination,
} from 'reports/actions';

import { valueFromEvent, saveAsCSV } from 'lib/util';
import { generateDisabledPDF } from 'lib/pdfs/DisabledPDF';

import FileSaver from 'file-saver';
import moment from 'moment';

class DisabledReportHandlers extends PureComponent {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    filters: PropTypes.shape({
      fulltext: PropTypes.string.isRequired,
      depreciationType: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
    }).isRequired,
    needFetch: PropTypes.bool.isRequired,
    pagination: PropTypes.shape({
      page: PropTypes.number.isRequired,
      limit: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
      orderBy: PropTypes.string.isRequired,
      order: PropTypes.string.isRequired,
    }).isRequired,
    render: PropTypes.func.isRequired,
  };

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.needFetch &&
      (!isEqual(nextProps.pagination, this.props.pagination) ||
        !isEqual(nextProps.filters.fulltext, this.props.filters.fulltext) ||
        !isEqual(nextProps.filters.accounts, this.props.filters.accounts) ||
        !isEqual(nextProps.filters.costCenters, this.props.filters.costCenters) ||
        !isEqual(nextProps.filters.employees, this.props.filters.employees) ||
        !isEqual(nextProps.filters.status, this.props.filters.status) ||
        !isEqual(nextProps.filters.endDate, this.props.filters.endDate))
    ) {
      this.fetchDebounce(nextProps.pagination, nextProps.filters);
    }
  };

  componentWillMount = () => this.fetch(this.props.pagination, this.props.filters);
  componentWillUnmount = () => this.props.reset();

  fetch = (pagination, filters) => {
    const { company, subcompany } = this.props;

    this.props.getReport(
      company.id,
      subcompany.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );
  };

  fetchDebounce = debounce(this.fetch, 200);

  handleExport = () => {
    const { company, subcompany } = this.props;

    this.props
      .getReportCSV(company.id, subcompany.id, this.props.filters)
      .then(({ value: { data } }) => saveAsCSV(`bajas`, this.props.filters.endDate, data))
      .catch((e) => {});
  };

  handleExportXLSX = () => {
    const { company, subcompany } = this.props;

    this.props
      .getReportXLSX(company.id, subcompany.id, this.props.filters)
      .then(({ value: { data } }) => {
        const dataArray = new Uint8Array(data);
        const blob = new Blob([dataArray], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        FileSaver.saveAs(blob, `bajas-${moment().format('DDMMYYYY')}.xlsx`);
      })
      .catch((e) => {});
  };

  handleExportPDF = () => {
    const { company, subcompany } = this.props;

    this.props
      .getReportPDF(company.id, subcompany.id, this.props.filters)
      .then(({ value: { data } }) => {
        console.log(data);
        generateDisabledPDF(
          this.props.company,
          this.props.filters.endDate,
          this.props.filters.depreciationType,
          data
        );
      })
      .catch((e) => console.log(e));
  };

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleFiltersSubmit = () => this.fetch(this.props.pagination, this.props.filters);

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  render = () =>
    this.props.render({
      handleExport: this.handleExport,
      handleExportPDF: this.handleExportPDF,
      handleFiltersChange: this.handleFiltersChange,
      handleFiltersSubmit: this.handleFiltersSubmit,
      handleLimitChange: this.handleLimitChange,
      handleOrderChange: this.handleOrderChange,
      handlePageChange: this.handlePageChange,
    });
}

const mapStateToProps = (state) => ({
  filters: getDisabledReportFilters(state),
  pagination: getDisabledReportPagination(state),
  needFetch: getDisabledReportNeedFetch(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  getReport: getDisabledReport,
  getReportCSV: getDisabledReportCSV,
  getReportPDF: getDisabledReportPDF,
  reset: resetDisabledReport,
  setFilters: setDisabledReportFilters,
  setPagination: setDisabledReportPagination,
};

export default connect(mapStateToProps, mapDispatchToProps)(DisabledReportHandlers);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/DisabledReportHandlers.js